import { useQuery } from '@tanstack/react-query';
import { COMMENT_LIST } from 'src/constants/queryKeys';
import axiosInstance from '../utils/axios';

export const networkGetCommentList = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`Comment/List?PageIndex=${pageIndex}&PageSize=${pageSize}`, payload);
  return res;
};

export function useFetchCommentList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [COMMENT_LIST, payload, pageIndex],
    queryFn: () => networkGetCommentList(payload, pageIndex, pageSize),
  });
}

export const networkUpdateComment = async (commentId, payload) => {
  const res = await axiosInstance.post(`Comment/Update/${commentId}`, payload);
  return res;
};
